export const CATEGORIES = [
  { id: "lepinja", label: "Roštilj u lepinji" },
  { id: "porcije", label: "Porcije" },
  { id: "kilo", label: "Na kilogram" },
  { id: "salate", label: "Pomfrit i salate" },
  { id: "pice", label: "Piće" },
];

export const MENU = {
  lepinja: [
    { name: "XL pljeskavica 150g", desc: "Klasik u lepinji — biraj priloge", price: 350 },
    { name: "XXL pljeskavica 300g", desc: "Naša najveća — za prave gladne", price: 550 },
    { name: "Ljuta pljeskavica 200g", desc: "Za hrabre — tucana u mesu", price: 450 },
    { name: "Punjena pljeskavica 300g", desc: "Kačkavalj, šunka, slanina", price: 550 },
    { name: "Filovana pljeskavica 200g", desc: "Kačkavalj, šunka", price: 500 },
    { name: "Ćevapi 200g", desc: "Klasika koja nikad ne greši", price: 450 },
    { name: "Kobasice 200g", desc: "Domaće kobasice sa žara", price: 400 },
    { name: "Pileći file 200g", desc: "Čisto belo meso, savršeno pečeno", price: 400 },
    { name: "Pileći batak 200g", desc: "Sočan, na ćumuru", price: 400 },
    { name: "Punjeni pileći file 300g", desc: "Kačkavalj, mocarela, slanina", price: 550 },
    { name: "Punjeni pileći batak 300g", desc: "Kačkavalj, šunka, slanina", price: 550 },
    { name: "Punjena vešalica 300g", desc: "Kačkavalj, mocarela, šunka, slanina", price: 550 },
    { name: "Pileća Karađorđeva 300g", desc: "Legenda kuće, vrela iznutra", price: 500 },
  ],
  porcije: [
    { name: "Porcija XL pljeskavica 150g", desc: "Meso + pomfrit + 3 priloga + lepinja", price: 450 },
    { name: "Porcija XXL pljeskavica 300g", desc: "Najveća porcija u kući", price: 650 },
    { name: "Porcija ljuta pljeskavica 200g", desc: "Za ljubitelje vatre", price: 550 },
    { name: "Porcija punjena pljeskavica 300g", desc: "Kačkavalj, šunka, slanina", price: 650 },
    { name: "Porcija filovana pljeskavica 200g", desc: "Kačkavalj, šunka", price: 600 },
    { name: "Porcija ćevapi 200g", desc: "Uz luk i pomfrit", price: 550 },
    { name: "Porcija kobasice 200g", desc: "Uz urnebes — savršeno", price: 500 },
    { name: "Porcija pileći file 200g", desc: "Lagano, a sasvim dovoljno", price: 500 },
    { name: "Porcija pileći batak 200g", desc: "Sočno i hrskavo", price: 500 },
    { name: "Porcija punjeni pileći file 300g", desc: "Kačkavalj, mocarela, slanina", price: 650 },
    { name: "Porcija punjeni pileći batak 300g", desc: "Kačkavalj, šunka, slanina", price: 650 },
    { name: "Porcija punjena vešalica 300g", desc: "Kačkavalj, mocarela, šunka, slanina", price: 650 },
    { name: "Porcija pileća Karađorđeva 300g", desc: "Obrok za pamćenje", price: 600 },
  ],
  kilo: [
    { name: "Mix 1kg", desc: "Pileći file, batak, kobasice, ćevapi", price: 1500 },
    { name: "Ćevapi 1kg", desc: "Po kilogramu — najjače", price: 1500 },
    { name: "Pljeskavice 1kg", desc: "Klasične pljeskavice", price: 1500 },
    { name: "Ljuta pljeskavica 1kg", desc: "Ljuta, na kilo", price: 1500 },
    { name: "Filovana pljeskavica 1kg", desc: "Kačkavalj, šunka", price: 1550 },
    { name: "Punjena pljeskavica 1kg", desc: "Kačkavalj, šunka, slanina", price: 1600 },
    { name: "Pileći file 1kg", desc: "Belo meso na kilo", price: 1400 },
    { name: "Pileći batak 1kg", desc: "Sočan batak na kilo", price: 1400 },
    { name: "Kobasice 1kg", desc: "Domaće kobasice", price: 1450 },
    { name: "Punjeni pileći file 1kg", desc: "Kačkavalj, mocarela, slanina", price: 1600 },
    { name: "Punjeni pileći batak 1kg", desc: "Kačkavalj, šunka, slanina", price: 1600 },
    { name: "Punjena vešalica 1kg", desc: "Premium rez", price: 1600 },
  ],
  salate: [
    { name: "Pomfrit 400g", desc: "Hrskav, vruć, obilan", price: 300 },
    { name: "Kupus salata", desc: "Svež kupus", price: 300 },
    { name: "Crni luk", desc: "Sveže seckan", price: 200 },
    { name: "Urnebes salata", desc: "Naša ponosna salata", price: 350 },
    { name: "Šopska salata", desc: "Sveža i hladna", price: 350 },
    { name: "Srpska salata", desc: "Paradajz, krastavac, luk", price: 350 },
    { name: "Lepinja", desc: "Vrela, sa žara", price: 80 },
  ],
  pice: [
    { name: "Coca-Cola 0,5l", desc: "Dobro rashlađena", price: 150 },
    { name: "Fanta 0,5l", desc: "Dobro rashlađena", price: 150 },
    { name: "Rosa voda 0,5l", desc: "Prirodna mineralna voda", price: 100 },
  ],
};

export const TOPPINGS = [
  "Pavlaka",
  "Kečap",
  "Majonez",
  "Urnebes",
  "Senf",
  "Tzatziki",
  "Ruska salata",
  "Ljutenica",
  "Marinada",
  "Feferone",
  "Šargarepa",
  "Paradajz",
  "Krastavac",
  "Zelena salata",
  "Kupus",
  "Vitaminska salata",
  "Crni luk",
  "Ljuta tucana paprika",
  "Vegeta",
  "So",
];
